




















import { Component } from 'vue-property-decorator';
import { mapState } from 'vuex';
import { namespace } from 'vuex-class';
import ClientDetail from '@/components/ClientDetail.vue';
// import { KCardHeader, FormPage }	from '@kasasa/fbase-components';
import { KCardHeader } from '@kasasa/fbase-components';
import FormPage from '@/components/FormPage.vue';
import { AuthGroupManager } from '@kasasa/fbase-components/lib';

const auth = namespace('auth');

@Component({
	components: {
		ClientDetail,
		KCardHeader
	},
	computed: {
		...mapState(['auth'])
	}
})
export default class ClientView extends FormPage {

	@auth.State('authManager') authManager!: AuthGroupManager;
	canWrite = false;
	title = '';
 
	created(): void {
		this.canWrite = this.authManager.canWrite('clients');
		this.title = this.canWrite ? 'Edit Client' : 'View Client';
	}

	get items(): Array<Record<string, unknown>> {	 
		return [
			{
				key: '0',
				text: 'Clients',
				disabled: false,
				link: true,
				exact: true,
				to: { name: 'Home' },
			},
			{
				key: '1',
				text: this.title,
				disabled: true,
			}
		];
	}
}
